import { render, staticRenderFns } from "./PostaDetails.vue?vue&type=template&id=2aba4b03&scoped=true&"
import script from "./PostaDetails.vue?vue&type=script&lang=js&"
export * from "./PostaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba4b03",
  null
  
)

export default component.exports